import MatchDetail from '@sone-pain/match-detail'
export default defineNuxtPlugin((nuxtApp) => {
  const MatchDetailDesktop = MatchDetail.MatchDesktop
  const MatchDetailMobile = MatchDetail.MatchMobile
  nuxtApp.vueApp.use(MatchDetailDesktop)
  nuxtApp.vueApp.use(MatchDetailMobile)
})
